<template>
  <div>
    <div class="login">
      <div class="logo">
        <a href="index.html">
          <img src="../assets/logo_transferh_full.png" alt="Logo TransfeRH" style="width:400px;">
        </a>
      </div>
      <div class="content">

        <!-- BEGIN LOGIN FORM -->
        <form id="formLogin" class="login-form" v-show="show.login">
            <h3 class="form-title font-green">Connexion</h3>
            <div class="form-group has-error">
                <!--ie8, ie9 does not support html5 placeholder, so we just show field title for that-->
                <label class="control-label visible-ie8 visible-ie9">Email</label>
                <input class="form-control form-control-solid placeholder-no-fix" type="text" autocomplete="off" data-parsley-trigger="change" placeholder="Email ou Username" required v-model="emailOrUsername"> </div>
            <div class="form-group has-error">
                <label class="control-label visible-ie8 visible-ie9">Mot de passe</label>
                <input class="form-control form-control-solid placeholder-no-fix" type="password" autocomplete="off" data-parsley-trigger="change" placeholder="Mot de passe" required v-model="password"> </div>
            <div class="form-actions">
                <a class="btn green uppercase" v-on:click="login()">Se connecter</a>
                <a class="forget-password" v-on:click="show.forgetPassword = true">Mot de passe oublié ?</a>
            </div>
        </form>
        <!-- END LOGIN FORM -->
        <!-- BEGIN FORGOT PASSWORD FORM -->
        <forget-password v-show="show.forgetPassword" :show.sync="show"></forget-password>
        <!-- END FORGOT PASSWORD FORM -->
        <!-- BEGIN RESET PASSWORD FORM -->
        <reset-password v-show="show.resetPassword" :show.sync="show"></reset-password>
        <!-- END RESET PASSWORD FORM -->
      </div>
      <div class="copyright"> 2017 © Le Web Français. Transferh. </div>
    </div>
  </div>
</template>

<script>

import storage from "../storage/data.js";

import ForgetPassword from './login/forgetPassword'
import ResetPassword from './login/resetPassword'

export default {
  name: 'login',
  components: {
    ForgetPassword,
    ResetPassword
  },
  data () {
    return{
      emailOrUsername:"",
      password:"test",
      error:"",
      show:{
        login:true,
        forgetPassword:false,
        resetPassword:false
      }
    }
  },
  watch: {
    'show.login': function(){
      if(this.show.login){
        this.show.forgetPassword = false;
        this.show.resetPassword = false;
      }
    },
    'show.forgetPassword': function(){
      if(this.show.forgetPassword){
        this.show.login = false;
        this.show.resetPassword = false;
      }
    },
    'show.resetPassword': function(){
      if(this.show.resetPassword){
        this.show.login = false;
        this.show.forgetPassword = false;
      }
    }
  },
  mounted:function(){
    if(this.$route.query && this.$route.query.resetPassword){
      this.show.resetPassword = true;
    }
  },
  methods:{
    login(){
      this.error = "";
      var parent = this;
      $('#formLogin').parsley().validate()
      if($("#formLogin").parsley().isValid()){

        storage.login(this,this.emailOrUsername,this.password,function(err){
          if(err){
            toastr.options.closeButton = true;
            toastr.options.timeOut = 7000;
            // toastr.options.progressBar = true;
            //toastr.options.positionClass = "toast-top-center",
            toastr.error(err,"ERREUR");
          }
          else{
            if(parent.$route.query && parent.$route.query.redirect){
              parent.$router.push(parent.$route.query.redirect);
            }
            else{
              parent.$router.push({name:'quizzes_list'});
            }
            // window.location.reload();
          }
        })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called.

    // Vérifier si l'user n'est pas déjà connecté, sinon redirection home.
    if(storage && storage.data && storage.data.session && storage.data.session.authenticated === true){
      next({name:"quizzes_list"});
    }
    else{
      next();
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login{
    background-color: #4f4f4f!important;
  }
</style>

<style src="../assets/theme/css/login.min.css"></style>



// WEBPACK FOOTER //
// login.vue?6ba16d52